import { render } from "./DossierSelected.vue?vue&type=template&id=a7784d72&scoped=true"
import script from "./DossierSelected.vue?vue&type=script&lang=js"
export * from "./DossierSelected.vue?vue&type=script&lang=js"

import "./DossierSelected.vue?vue&type=style&index=0&id=a7784d72&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7784d72"]])

export default __exports__